import { ElectronApi } from '@/services/electron.api';
import { WatchfaceService } from '@/services/watchface';
import { useFormatsStore } from '@/store/use-formats-store';
import { useImagesStore } from '@/store/use-images-store';
import { testAccess } from '@/utils/fs/fs-extra.utils';
import { imgutils } from '@/utils/imgutils';
import { useRouteState } from './use-route-state';
import { canUse } from '@/utils/can-use.utils';
import { getImageBase64 } from '@/utils/fs/image.utils';
import { hasTransparentPixel } from '@/utils/transform-image';

export const useImageAutoFormat = () => {
  const imageStore = useImagesStore();
  const formatStore = useFormatsStore();
  const { isEditorPage } = useRouteState();

  const _decideCompressionFormat = async (imagePath: string) => {
    if (!canUse('indexed-color').valid) {
      const imgUrl = await getImageBase64(imagePath);
      if (!imgUrl) throw '无法读取本地图片';
      return (await hasTransparentPixel(imgUrl)) ? 'argb8888' : 'rgb565';
    }
    try {
      const format = await imgutils.decideCompression(imagePath);
      const _format =
        format == 'true-color'
          ? 'truecolor'
          : format == 'true-color-alpha'
          ? 'truecolor_alpha'
          : format;
      return _format;
    } catch (error) {
      console.error('获取图片格式错误，使用默认格式indexed8');
      console.error(error);
      return 'indexed8' as const;
    }
  };
  const resetImgsFormat = async () => {
    const imgsData = imageStore.imgs;
    const watchfaceService = new WatchfaceService();
    const path = ElectronApi.path;
    const resourcePath = watchfaceService.ResourcePath;
    const canUseIndexedColor = canUse('indexed-color').valid;

    for (const item of imgsData) {
      if (!isEditorPage.value) break;
      if (!item) continue;
      const { basename, realpath } = item;
      // 查看是否存在缓存
      const cachedVal = formatStore.format(basename);

      // 如果缓存不存在，或者不是indexed8
      if (
        !cachedVal || canUseIndexedColor
          ? cachedVal != 'indexed8'
          : cachedVal != 'argb8888'
      ) {
        // 获取图片路径
        const imagePath = realpath
          ? realpath
          : path?.join(resourcePath, ...basename.split('/'));
        if (!imagePath || !(await testAccess(imagePath))) continue;
        const format = await _decideCompressionFormat(imagePath);
        if (format) {
          formatStore.add(basename, format);
        }
      }
    }
  };
  return {
    resetImgsFormat
  };
};
